"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _api = require("../helpers/api.js");
var _constants = require("../constants");
var _createAction = require("../helpers/createAction.js");
var DeviceRegistrations = /*#__PURE__*/_createClass(function DeviceRegistrations(api) {
  var _this = this;
  _classCallCheck(this, DeviceRegistrations);
  this.deviceRegistrationCreate = (0, _createAction.createApiRequestAction)({
    getKey: function getKey() {
      return 'device-registrations';
    },
    request: function request(getState, fcmToken, deviceType, vendorId, appName, bundleId) {
      return _this.api.post("".concat((0, _api.currentUserUrl)(getState()), "/device_registrations"), {
        device_registration: {
          vendor_identifier: vendorId,
          bundle_identifier: bundleId,
          device_type: deviceType,
          fcm_token: fcmToken,
          app_name: appName
        }
      });
    },
    loadingConstant: _constants.DEVICE_REGISTRATION_CREATING,
    loadedConstant: _constants.DEVICE_REGISTRATION_CREATED,
    errorConstant: _constants.DEVICE_REGISTRATION_ERROR
  });
  this.api = api;
});
var _default = exports.default = DeviceRegistrations;